import { render, staticRenderFns } from "./EditUserProfile.vue?vue&type=template&id=0ba8666e&scoped=true&"
import script from "./EditUserProfile.vue?vue&type=script&lang=js&"
export * from "./EditUserProfile.vue?vue&type=script&lang=js&"
import style0 from "./EditUserProfile.vue?vue&type=style&index=0&id=0ba8666e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba8666e",
  null
  
)

export default component.exports